<template>
  <page>
    <head-nav :title="$t('language.absence_procedure')">
       <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

    <scroll-page :pull-reload="false">


    <page-padding>
    <div>{{appSettings.modules.absence.message}}</div>
    </page-padding>


    <div v-if="appSettings.school_app_footer" class="footer">
        <img class="f-img" :src="appSettings.school_app_footer">
      </div>

     </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../components/PagePadding.vue';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ScrollPage from '../components/ScrollPage.vue';
//import CatchLink from '../components/CatchLink.vue';

export default {
  name: 'contact-page',
  data:function(){
    return {
      school:{},
    }
  },
  methods:{
  },
  computed:{
     ...mapState([
       'appSettings','user_schools'
       ]),
      computeSchoolUrl(){
        return (this.school.url) ? 'https://' + this.school.url : ""; 
      }
  },
  components:{
    ScrollPage,
    PagePadding,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
   // CatchLink,
  },
  created(){
  },
  mounted(){
    this.school=this.user_schools.find(school => school.active === 1)
  },
  beforeDestroy(){
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center-text{
  text-align: center;
  margin-bottom:10px;
}
.extra{
  margin-top:10px;
}
img{
  max-width: 60%;
}
.footer{
  margin-top:15px;
  display:flex;
  justify-content: center;
}
.footer .f-img{
  width:80%;
   max-width:250px;
   height:auto;
}
.icon{
  margin-right:5px;
}
</style>
